import * as Yup from "yup";

const regExp = new RegExp(/^(?=\S*[a-zA-Z])(?=\S*[0-9])(?=\S{8,})/);

export const validatorPassword = Yup.string().matches(regExp, {
  excludeEmptyString: true,
  message:
    "Password must have a minimum of 8 characters, include at least 1 digit and 1 letter and cannot include spaces"
});
